import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RootState } from "../../../redux/store";
import { QuestionProps } from "../../../typings/register";
import { getPersonalStatusQuestion } from "../../../services/questionService";
import { updateMemberPersonalStatus } from "../../../services/memberService"
import QuestionUpdateHeader from './QuestionUpdateHeader';
import EditTagQuestion from '../../../components/EditTagQuestion';

const UpdatePersonalStatusQuestion = () => {

    const [isLoading, setIsLoading] = useState<boolean>();
    const [question, setQuestion] = useState<QuestionProps>();
    const { memberCode: myMemberCode } = useSelector((state: RootState) => state.member);
    let history = useHistory();

    useEffect(() => {
        getAndSetQuestion();
    }, [])


    const getAndSetQuestion = async () => {
        setIsLoading(true);
        const { data } = await getPersonalStatusQuestion(myMemberCode);
        setQuestion(data);
        setIsLoading(false);
    };

    const onSave = async (tags: number[]) => {
        if (question) {
            await updateMemberPersonalStatus(myMemberCode, tags[0]);
            history.goBack();
        }

    };

    return (
        <>
            {
                question && question.tags ?
                    <>
                        <QuestionUpdateHeader />
                        <EditTagQuestion
                            title={question.question}
                            subtitle={question.questionSubTitle}
                            buttonText={"שמור"}
                            tags={question.tags}
                            onSave={onSave}
                            selectedTagValue={question.tags.filter(x => x.isSelected).map(x => x.value)[0]}
                        />
                    </>
                    :
                    null
            }


        </>
    )
}

export default UpdatePersonalStatusQuestion;